import { DatePipe, DOCUMENT, Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input,RendererStyleFlags2, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDateService, NbDialogService, NbPopoverDirective } from '@nebular/theme';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { NgxPrintElementService } from 'ngx-print-element';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { AdmissionMasterData } from '../../../@core/interfaces/Ip/admissionMaster';
import { DischargeTmplData } from '../../../@core/interfaces/masters/discharge-tmpl';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { PrinterSettingsData } from '../../../@core/interfaces/masters/printersettings';
import { ServiceCategoryData } from '../../../@core/interfaces/masters/servicecategory';
import { TenantBranchData } from '../../../@core/interfaces/masters/tenantbranch';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { PrintServiceService } from '../../../@theme/components/common/service/print-service.service';
import { commonsettings } from '../../../data/ezoTempSettings';
import { PhysicianData } from './../../../@core/interfaces/masters/physician-mst';
import { SummaryData, SummaryFields, SummaryMst } from './../../../@core/interfaces/patient-services/summary';
import * as title from './../../../data/title.json';
import { RadiologyComponent } from '../../../@theme/components/common/radiology/radiology.component'; 


@Component({
  selector: 'ngx-radiology-summary-template',
  templateUrl: './radiology-summary-template.component.html',
  styleUrls: ['./radiology-summary-template.component.scss']
})
export class RadiologySummaryTemplateComponent implements OnInit {

  admissionId: number = 0;
  visitId: any;
  regId: any;
  p: number = 1;
  isEditComponnet: boolean = false;
  isAddComponnet: boolean = false;
  term: string;
  protected readonly unsubscribe$ = new Subject<void>();
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private createdBy = localStorage.getItem("userId");
  
  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = false;
  detForm: FormGroup; 
  fields: SummaryFields[];
  dupTitle:boolean;
  selected: SummaryMst; 
  isBtnSubmitted: boolean = false;
  printmsg:boolean =false;
  errorLabel: boolean = false;
  saveMsg:boolean=false; 
  save_discharge_summary:boolean=false;
  update_discharge_summary:boolean=false;
  cancel_summary:boolean=false;
  @Input("dynamicVal") dynamic: boolean = false;
  @Input() fromMst: boolean = false;
  patDet: any;
  multiSelectFields: SummaryFields[];
  dynamicFieldsList: SummaryFields[] = [];
  templateData:any=null;
  
  @Input() visitDoctorid:any;
  visitDoctor: string;
  @Input() admissionDetails:any;
  visitDoctorDeptId:any;
  printCertificateTitle:boolean;
  data: any=[];
  sumMstData:any=[];

  srcname= !!localStorage.getItem('TenantHospitalImg')?localStorage.getItem('TenantHospitalImg'):'/assets/images/white.png';
  fontStyleLists=commonsettings.font_style_lists;
  commonSettings=commonsettings.template;
  tempdecSettings=commonsettings.body

  templateForm:FormGroup;
  fontdialogForm:FormGroup;
  templatePreview:any;
  topHeaderLines: FormArray;
  bodyItemLines: FormArray;
  FooterLines: FormArray;
  commonStylechange="";

  pageTitleList:any=[];
  pageTitleSetttings:any=JSON.parse(JSON.stringify(commonsettings.template?.page_title))
  objectKeys = Object.keys;
  itemBodyList:any=[];
  
  docname2;
  patientid;
  patientmno;
  patientname;

  duplicateMsg: boolean;
  erroeSavemsg: boolean;
  savedSuccessMsg: boolean;
  duplicateDischarge: boolean;
  savedSettingMsg: boolean;
  isSubmitted:boolean;
  editDischargeData:any;
  onloadeditdata:any;
  cancelDialog:boolean=false;
  onPreviewDialog:boolean=false;
  currenteditorindex;
  selectsummarymst:any;
  loadText = "Updates are in progress. Please wait";
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective; 
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;

  public config = {
    printMode: 'template-popup',
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'mri',
    stylesheets: [{ rel: 'stylesheet', href: '/assets/css/print.css' },
              { rel: 'stylesheet', href: '/assets/css/custom.css' },
                { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css' },
    ],
    styles: [ 
    commonsettings.printCommonStyle
    ]
  };
  itemvalue:any=[];

  editorConfig: any = { 
      width:'auto',
      height: 100,  
      plugins:
      'print preview fullpage searchreplace autolink \
       directionality visualblocks visualchars fullscreen \
       image imagetools  media  table template codesample preview \
       charmap hr pagebreak nonbreaking anchor insertdatetime \
       advlist lists textcolor wordcount contextmenu colorpicker textpattern autoresize link image code', 
      toolbar:
      'fontselect bold italic forecolor fontsizeselect strikethrough backcolor \
       alignleft aligncenter alignright alignjustify table lineheight \
       numlist bullist outdent indent preview fullscreen code  ',        
      image_advtab: true,
      imagetools_toolbar:
      'rotateleft rotateright | flipv fliph | editimage imageoptions',
      toolbar_location: 'bottom', 
      statusbar : false,
      toolbar_mode: 'floating',
      menubar:false,  
      content_security_policy: "default-src 'self'",
      nonbreaking_force_tab: true,
      setup: function(editor) {
        editor.on('init', function(e) { 
        });
      },
      init_instance_callback: function(editor) {
        editor.on('ExecCommand', function(e) { 
          if("LineHeight"==e.command){  
          }
        });
      }
    // superscript subscript anchor
  };
  titleList: any = (title as any).default;

  changeThemeNotifyDialog:boolean=false;
  @ViewChild('printcontent', {static: false}) printcontent: ElementRef;
  @ViewChild('downloadpdf')  downloadpdf: ElementRef;
  downloadHtml='';  
  pageTilte: any;
  headerDet: any;
  woDetId: any;
  wonumber: any;
  sstemp: any;
  showTemplate: boolean;
  moduleName: string;
  @Input() ehr;
  @Input() sstempEhr: any;
  @Input() wonumberEhr: any;
  @Input() regIdEhr: any;
  @Input() woDetIdEhr: any;
  @Input() status:string

  constructor(
    // printer settings constructor object create start by RAJA:) 
    private radComponent: RadiologyComponent,
    private iatchSrvc: imageatch_detData,
    protected psSrvc:PrinterSettingsData,
    public PrintServiceService:PrintServiceService,
    @Inject(DOCUMENT) public document: any,
    // printer settings constructor object create:) 
   public datesrcv:DateService,
   private elementRef: ElementRef, 
   public location:Location,public spinner:NgxSpinnerService,
   protected phySrvc: PhysicianData,protected rolesService: RolesData, private changeDetectorRef: ChangeDetectorRef, private fb: FormBuilder, private sumSrvc: SummaryData,
   private datePipe: DatePipe, protected dateService: NbDateService<Date>, private route: ActivatedRoute,public sanitizer: DomSanitizer,
   protected patRegSrvc: PatientRegistrationData, private router: Router, private renderer: Renderer2,protected tenantBrchSrvc: TenantBranchData,private dialogService: NbDialogService,public printsrvc: NgxPrintElementService,private admissionMasterService: AdmissionMasterData,protected DischargeTmplSrvc: DischargeTmplData,
   protected srvc : ServiceCategoryData) {
     this.detForm = this.generateForm();
     this.moduleName='Radiology';
      this.fontdialogForm = this.fb.group({
        elementVal: this.fb.control(null),
        fontfamily: this.fb.control(this.commonSettings?.fontfamily),
        fontColor: this.fb.control('#333333'),
        fontSize: this.fb.control(12),
        isBold: this.fb.control(false),
        isItalic: this.fb.control(false),
        isUnderline: this.fb.control(false),
        linespace: this.fb.control(1),
        textAlign: this.fb.control("left"),
        outdent: this.fb.control(0),
        indent: this.fb.control(0),
        textheight: this.fb.control(1)
      });
      this.templateForm = this.fb.group({
        //Template prop
        templatename: this.fb.control(null,[Validators.required,],),
        tmplCommonFlag:this.fb.control(null),
        tmplReportHeader:this.fb.control(null),
        tmplReportFooter:this.fb.control("Header"),
        tmplDisplayDept:this.fb.control("Footer"),
        tmplDisplayPhy:this.fb.control(null),
        tmplDisplaySettings:this.fb.control(null),
        tmplActiveFlag:this.fb.control(null),
        ps:this.fb.control('A4',[Validators.required,],),
        orientation:this.fb.control('Portrait',[Validators.required,],),
        lm:this.fb.control(10,[Validators.required],),
        rm:this.fb.control(10,[Validators.required],),
        tm:this.fb.control(10,[Validators.required],),
        bm:this.fb.control(10,[Validators.required],),
        id: this.fb.control(null),
        height: this.fb.control(null),
        width: this.fb.control(null),
        bgColor: this.fb.control('#ffffff'),
        labelColor: this.fb.control('#333333'),
        fontColor: this.fb.control('#333333'),
        fontSize: this.fb.control(12),
        fontfamily: this.fb.control(this.commonSettings?.fontfamily),
        imagewidth: this.fb.control(60),
        temptype: this.fb.control(null),
        //Header 
        topHeaderRequired: this.fb.control(true),      
        topHeaderLogoRequired: this.fb.control(true),
        topHeaderLogoPosition: this.fb.control('center start'),
        topHeaderPosition: this.fb.control('center end'),
        topHeaderheight: this.fb.control(60),
        topHeaderlineheight: this.fb.control(18),
        topHeaderLines: new FormArray([]),
        topheaderbgColor: this.fb.control('#ffffff'),
        topheaderfontColor: this.fb.control('#333333'),
        topheaderfontfamily: this.fb.control(this.commonSettings?.fontfamily),
        pageTitle: this.fb.control(this.pageTilte),
        pageTitlefontsize: this.fb.control(14),
        reportHeaderPlacement: this.fb.control('center center'),
        pageTitleHeaderRequired: this.fb.control(true),
        // 
        pageTitleData: this.fb.control(true),
        // Body Table
        bodyItemLines: new FormArray([]),
        bodyHeader:this.fb.group({
          itemname: this.fb.control(1),
          itemvalue: this.fb.control(null),
          itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
          itemfontcolor: this.fb.control(this.commonSettings.fontColor),
          itemfontsize: this.fb.control(this.commonSettings.fontSize),
          itemisdisplay: this.fb.control(true),
          itemposition: this.fb.control('Left'),
          itemismandatory: this.fb.control(false),
          itemtype: this.fb.control('Body'),
        }),
        bodyValue:this.fb.group({
          itemname: this.fb.control(1),
          itemvalue: this.fb.control(null),
          itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
          itemfontcolor: this.fb.control(this.commonSettings.fontColor),
          itemfontsize: this.fb.control(12),
          itemisdisplay: this.fb.control(true),
          itemposition: this.fb.control('Left'),
          itemismandatory: this.fb.control(false),
          itemtype: this.fb.control('Body'),
        }),  
        
        tblrow: this.fb.control(1),
        tblcol: this.fb.control(1),
        bodylayout: this.fb.control('Top Bottom'),
        //Footer
        FooterRequired: this.fb.control(null),
        FooterLogoRequired: this.fb.control(null),      
        FooterLogoPosition: this.fb.control(null),
        FooterPosition: this.fb.control(null),
        Footerheight: this.fb.control(60),
        Footerlineheight: this.fb.control(18),
        FooterLines: new FormArray([]),
        FooterbgColor: this.fb.control('#ffffff'),
        FooterfontColor: this.fb.control('#333333'),
        Footerfontfamily: this.fb.control(this.commonSettings?.fontfamily),
        bottomDocsignrequired: this.fb.control(null),
        bottomDocsignPosition: this.fb.control('center end'),
        bottomDocsignLabel: this.fb.control('Dr Name'),
        bottomDocsignLabelsize: this.fb.control(12),
        bottomDocsignimg: this.fb.control(null),
        bottomDocsignftcol: this.fb.control('#000000'),
  
        FooterLine1: this.fb.control(null),
        FooterLine2: this.fb.control(null),
        FooterLine3: this.fb.control(null),
        FooterLine4: this.fb.control(null),
        reportHeader: this.fb.control(null),
        reportFooter: this.fb.control(null),        
       });  
     this.fontdialogForm.valueChanges.subscribe(data => this.onFontDialogValueChanged(data));
   }

  ngOnInit(): void {
      this.sstemp = this.sstempEhr;
      this.wonumber = this.wonumberEhr;
      this.regId = this.regIdEhr;
      this.woDetId = this.woDetIdEhr;
    if(this.sstemp == 'CT' || this.sstemp == 'Ct Scan'){this.pageTilte= 'Radiology_CT';}
    else if (this.sstemp == 'XRay'){this.pageTilte= 'Radiology_XRAY';}
    else if (this.sstemp == 'MRI'){this.pageTilte= 'Radiology_MRI';}
    else if(this.sstemp =='MammograM'){this.pageTilte='Radiology_Mamogram';}
    else if (this.sstemp == 'Usg'){this.pageTilte='Radiology_USG';}
    else if (this.sstemp == 'Mediscan' || this.sstemp == 'Dexa'){this.pageTilte='Radiology_Dexa';}
    else if (this.sstemp == 'DoppleR'){this.pageTilte='Radiology_Doppler';}
    else if (this.sstemp == 'Ultra Sound' || this.sstemp == 'Sonography'){this.pageTilte='Radiology_Sono';}
    else if (this.sstemp == 'ECHO'){this.pageTilte='Radiology_ECHO';}
    else if (this.sstemp == 'ECG'){this.pageTilte='Radiology_ECG';}
    else if (this.sstemp == 'Colonoscopy'){this.pageTilte='Radiology_Colonoscopy';}
    else if (this.sstemp == 'Fluoroscopy'){this.pageTilte='Radiology_Fluroscopy';}
    else if (this.sstemp == 'Nuclear'){this.pageTilte='Radiology_Nuclear';}
    else if (this.sstemp == 'Neuro'){this.pageTilte='Radiology_Neuro';}
    else {this.pageTilte='';}
    this.loadHeader(this.wonumber,this.regId,this.status);
    this.LoadDischargeTmpls();
  }

  closeTemplate(){
    this.radComponent.radTemplateCancel();
  }

  // It loading the Templates :
  LoadDischargeTmpls(): void { 
    this.DischargeTmplSrvc.list("dischargeTmpl/" + this.tenandId+'/getTemplateInfoByTemplateType/'+this.pageTilte ).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.data=data?.filter(x=>x.isActive=="Y");
    }, (error) => {
    }, () => {
      if(this.data.length>0){
          this.showTemplate=true;
      }
      else{
        this.showTemplate=false;
      }
      this.loaddataonEdit();  
    });
  }
  
  loaddataonEdit(){
    if(!!this.woDetId){
       this.DischargeTmplSrvc.list(`PatientDischargeTmpl/${this.tenandId}/${this.branchId}/GetPatientTemplByWorkOrder/${this.regId}/${this.wonumber}/${this.woDetId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((dataonEdit: any) => {      
        if(!!dataonEdit?.header){ 
          this.detForm.controls['fieldsSelect'].setValue(dataonEdit?.header?.templateId);
          this.detForm.controls['fieldsSelect'].disable();
          this.onloadeditdata=dataonEdit;
          this.editDischargeData=dataonEdit;
        var datas={
          "id": dataonEdit?.header?.templateId,
          "tenant": null,
          "tmplName": "Testaa",
          "tmplCommonFlag": "N",
          "tmplReportHeader": null,
          "tmplReportFooter": null,
          "tmplDisplaySettings": "{\"bgColor\":\"#ffffff\",\"bgimage\":null,\"imagewidth\":60,\"bgposition\":null,\"ps\":\"A4\",\"orientation\":\"Portrait\",\"tm\":10,\"bm\":10,\"lm\":10,\"rm\":10,\"bodylayout\":\"Left Right\",\"temptype\":\"dischargeSummary\",\"labelColor\":\"#333333\",\"fontColor\":\"#333333\",\"fontSize\":12,\"fontfamily\":\"\\\"Roboto\\\", sans-serif\"}",
          "tenantId": "5c78ce3a-b51f-421b-1087-08d8bc9e85dc",
          "createdDate": new Date(),
          "updatedDate": new Date(),
          "createdBy": 113,
          "updatedBy": 113,
          "createdIP": "ip",
          "updatedIP": "ip",
          "tmplActiveFlag": "N",
          "tempTitle": "{\"topHeaderLogoPosition\":\"center start\",\"topHeaderLogoRequired\":true,\"topHeaderPosition\":\"center end\",\"topHeaderRequired\":true,\"topHeaderheight\":60,\"topHeaderlineheight\":18,\"topheaderbgColor\":\"#ffffff\",\"topheaderfontColor\":\"#333333\",\"topheaderfontfamily\":\"\\\"Roboto\\\", sans-serif\",\"pageTitle\":\"mri\",\"pageTitleHeaderRequired\":true,\"pageTitlefontsize\":14,\"topHeaderLines\":[{\"name\":\"Hospital Name\",\"value\":\"Ezovion Hospital\",\"fontsize\":14},{\"name\":\"Address 1\",\"value\":\"Chennai - 625513\",\"fontsize\":12},{\"name\":\"Address 2\",\"value\":\"\",\"fontsize\":12},{\"name\":\"Contact Details\",\"value\":\"8754458333\",\"fontsize\":12},{\"name\":\"Field 5\",\"value\":\"\",\"fontsize\":12}]}",
          "footer": "{\"FooterLogoPosition\":null,\"FooterLogoRequired\":null,\"FooterPosition\":null,\"FooterRequired\":null,\"FooterbgColor\":\"#ffffff\",\"FooterfontColor\":\"#333333\",\"Footerfontfamily\":\"\\\"Roboto\\\", sans-serif\",\"Footerheight\":60,\"Footerlineheight\":18,\"bottomDocsignLabel\":\"Dr Name\",\"bottomDocsignLabelsize\":12,\"bottomDocsignPosition\":\"center end\",\"bottomDocsignftcol\":\"#000000\",\"bottomDocsignimg\":null,\"bottomDocsignrequired\":null,\"bottomLines\":[{\"name\":\"Hospital Name\",\"value\":\"Ezovion Hospital\",\"fontsize\":14},{\"name\":\"Address 1\",\"value\":\"Chennai - 625513\",\"fontsize\":12},{\"name\":\"Address 2\",\"value\":\"\",\"fontsize\":12},{\"name\":\"Contact Details\",\"value\":\"8754458333\",\"fontsize\":12},{\"name\":\"Field 5\",\"value\":\"\",\"fontsize\":12}]}",
          "pageTitle": "{\"column\":2,\"row\":5,\"ft_lbl_color\":\"#474747\",\"ft_lbl_size\":11,\"ft_value_color\":\"#000000\",\"ft_value_size\":12,\"fields\":[{\"name\":\"headinglabel\",\"header\":\"Patient Information\",\"value\":null,\"display\":true,\"heading\":true,\"new\":\"old\"},{\"name\":\"field12\",\"header\":\"ddsdsd\",\"value\":\"dsdsd\",\"display\":true,\"heading\":false,\"new\":\"new\"},{\"name\":\"pname\",\"header\":\"PL Name\",\"value\":\"KUMAR SAMYNATHAN\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"field11\",\"header\":\"ewewe\",\"value\":\"ewersdsd\",\"display\":true,\"heading\":false,\"new\":\"new\"},{\"name\":\"agegender\",\"header\":\"Age/Gender\",\"value\":\"47 Y 7 M 26 D\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"regno\",\"header\":\"Reg.No\",\"value\":\"7\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"address\",\"header\":\"Address\",\"value\":\"{patientaddress}\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"headinglabel\",\"header\":\"Admission Information\",\"value\":null,\"display\":true,\"heading\":true,\"new\":\"old\"},{\"name\":\"admdate\",\"header\":\"Admission Date\",\"value\":\"2022-06-06 12:46 PM \",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"disdate\",\"header\":\"Discharge Date\",\"value\":\"\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"ipno\",\"header\":\"IP.No\",\"value\":\"31\",\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"roombedno\",\"header\":\"Room/Bed.No\",\"value\":null,\"display\":true,\"heading\":false,\"new\":\"old\"},{\"name\":\"Doctor\",\"header\":\"Doctor\",\"value\":\"Dr. TEST (Ca R Dio Logy) / Ca R Dio Logy\",\"display\":true,\"heading\":false,\"new\":\"old\"}]}",
          "detlist": "Patient's Name ,2. Mobile No ,3. UHID ,5. Treating Consultant/s Name ,a. Contact Number ,b. Department ,6. Date Of Admission With Time ,7. Date Of Discharge With Time ,8. MLC No ,9. Provisional DiagnosisAt The Time Of Admission ,10. Final DiagnosisAt The Time Of Discharge ,11. Presenting Complaints With DurationAnd Reason For Admission ,12. Summary Of Presenting Illness ,13. Key Findings, On Physical Examination At The Time Of Admission ,14. History Of Alcoholism, Tobacco OrSubstance Abuse, If Any ,15. Significant Past Medical And Surgical History, If Any ,16. Family History If Significant / Relevent To Diagnosis Or Treatment ,17. Summary Of Key Investigations During Hospitalization ,18. Treatment Given ,19. Course In The Hospital Including Complications, If Any ,20. Patient Condition At The Time Of Discharge ,21. Advice On Discharge ,22. Review On ,23. In Case Of Complications Such As,",
          "dischargeTmplDet": dataonEdit?.details
        }
        this.templateData=datas;   
          this.templateData.tempTitle=this.onloadeditdata?.header?.temptitle;
          if(!!this.onloadeditdata?.header?.footer) this.templateData.footer=this.onloadeditdata?.header?.footer;
          if(!!this.selectsummarymst && !!this.selectsummarymst?.pageTitle) {
            this.templateData.pageTitle = this.selectsummarymst?.pageTitle
          }
          else{
           this.templateData.pageTitle=this.onloadeditdata?.header?.pagetitle;
          }
          this.templateData.tmplDisplaySettings==this.onloadeditdata?.header?.displaySettings;
          this.templateData.dischargeTmplDet=this.onloadeditdata?.details; 
          this.editdata(this.templateData);
       }
       else{
          this.onloadeditdata=null;
          this.templateData=null;
          this.editDischargeData=null;
       }
      }, (error) => {
      }, () => { 
    });
   }
  }

  openExistingSummary(){
    this.closeTemplateDialog();
    this.router.navigate([`/pages/ip/new-dashboard/${this.regId}/${this.admissionId}`], { queryParams: { pageName:'DischargeSummary' } });
  }
  changeTemplate(){
    this.changeThemeNotifyDialog=true;
  }
  closeTemplateDialog(){
    this.changeThemeNotifyDialog=false;
    this.changeThemeNotifyDialog=false;
  }
  chnageTemplateOK(){
    this.detForm.controls['fieldsSelect'].enable();
    this.detForm.enable();
    this.changeThemeNotifyDialog=false;
  }
  get fval():{[key: string]: AbstractControl} { return this.templateForm.controls; } 
  get fval1():{[key: string]: AbstractControl} { return this.fontdialogForm.controls; }  
  get apiUrl() {   return environment.baseUrl;  }

  generateForm(): FormGroup { 
    
    const baseForm = this.fb.group({});
    baseForm.addControl("fieldsSelect", new FormControl(null));
    baseForm.addControl("sumType", new FormControl(null));
    baseForm.addControl("title", new FormControl(null, [Validators.maxLength(50)]));
    this.sumSrvc.list(`${this.apiUrl}/patSum/${this.tenandId}/${this.branchId}/fields`).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.fields =data;
      this.multiSelectFields = this.fields.filter(t => t.tblName && t.tblName.toLocaleLowerCase().indexOf("patientregistration") > -1);      
      this.fields.forEach(y => {
        baseForm.addControl(y.fieldName, new FormControl(null));
      });
      this.detForm = baseForm;
      return baseForm;
    }, (error) => {
      this.detForm = baseForm;
      return baseForm;
    }, () => {
      this.fetchPatDetails();
    }
    );
    return baseForm;
  }
  fetchPatDetails(): void {
    
    if (this.regId !== null && this.regId !== undefined) {
      this.patRegSrvc.getById("patientregistrationmst/" + this.tenandId + '/' + this.branchId + '/' + this.regId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.patDet = data; 
        this.patDet.dob = this.datePipe.transform(data.dob, 'mediumDate');
        this.multiSelectFields.forEach(det => {
          if (this.patDet[det.columnName] != null && this.patDet[det.columnName] != undefined)
            this.detForm.controls[det.fieldName].setValue(this.patDet[det.columnName]);
        }); 
      }, (error) => {

      }, () => {

      });
    }
    else
      return;
  }
  ngOnDestroy(): void {
    
    this.itemvalue=this.itemvalue?.map((x,index)=>{
      x.displayeditor=false;
      x.displaytext=false;
      return {...x}
    })
  }

  // PageName based template on onchange event :
  onChange(args) {  
    this.selectsummarymst=args[0]?.data;
    this.editDischargeData=null;
    this.templateData=args[0]?.data;  
    this.editdata(this.templateData);
  } 

  async editdata(data){  
    this.templateForm.controls['templatename'].setValue(data?.tmplName);
    this.templateForm.controls['tmplCommonFlag'].setValue(data?.tmplCommonFlag=='Y'?true:false);
    this.templateForm.controls['tmplReportHeader'].setValue(data?.tmplReportHeader);
    this.templateForm.controls['tmplReportFooter'].setValue(data?.tmplReportFooter);
    this.templateForm.controls['tmplDisplayDept'].setValue(data?.tmplDisplayDept=='Y'?true:false);
    this.templateForm.controls['tmplDisplayPhy'].setValue(data?.tmplDisplayPhy=='Y'?true:false);
    this.templateForm.controls['tmplDisplaySettings'].setValue(JSON?.parse(data?.tmplDisplaySettings));
    this.templateForm.controls['tmplActiveFlag'].setValue(data?.tmplActiveFlag=='Y'?true:false); 
    var template={...JSON.parse(data?.tmplDisplaySettings),
      temp_title:JSON.parse(data?.tempTitle),
      page_title:JSON.parse(data?.pageTitle),
      footer:JSON.parse(data?.footer)}  
    this.templateForm.controls['bgColor'].setValue(template?.bgColor);
    this.templateForm.controls['imagewidth'].setValue(template?.imagewidth);
    this.templateForm.controls['ps'].setValue(template?.ps);
    this.templateForm.controls['orientation'].setValue(template?.orientation);
    this.templateForm.controls['tm'].setValue(template?.tm);
    this.templateForm.controls['bm'].setValue(template?.bm);
    this.templateForm.controls['lm'].setValue(template?.lm);
    this.templateForm.controls['rm'].setValue(template?.rm);
    this.templateForm.controls['labelColor'].setValue(template?.labelColor);
    this.templateForm.controls['fontSize'].setValue(template?.fontSize);
    this.templateForm.controls['fontfamily'].setValue(template?.fontfamily);
    this.templateForm.controls['bodylayout'].setValue(template?.bodylayout);
    this.templateForm.controls['temptype'].setValue(template?.temptype);
 
    this.pageTitleSetttings=template?.page_title,
    this.pageTitleList=template?.page_title?.fields; 
    this.pageTitleList=this.pageTitleList?.map(x=>{
      if(!!x.value)
        x.value=this.replaceVariableTostring(x.value);
      return {...x}
    });  
    (this.templateForm.get('bodyItemLines') as FormArray).clear();
    this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
    var bodyitmes=data?.dischargeTmplDet;
    this.itemvalue=[];
    bodyitmes?.filter(async (x,index)=>{ 
      var headerjson={
        "itemfontfamily":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontfamily,
        "itemfontcolor":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontColor,
        "itemfontsize":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontSize, 
        "itemposition":JSON.parse(x.rowSettings)?.header?.fontstyle?.textAlign,
      }
      var valuejson={
        "itemfontfamily":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontfamily,
        "itemfontcolor":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontColor,
        "itemfontsize":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontSize, 
        "itemposition":JSON.parse(x.rowSettings)?.value?.fontstyle?.textAlign,
      }  
      var disSummary= x.rowDefaultValue; 
      disSummary=this.replaceVariableTostring(disSummary);
      this.itemvalue.push({value:disSummary,displayeditor:false,displaytext:true});
      var headername=!!x?.rowHeader?x?.rowHeader:x?.rowHeaderName
      this.bodyItemLines.push(this.fb.group({
        header:{itemvalue:headername,...JSON.parse(x.rowSettings).header,...headerjson},
        value: {itemvalue:disSummary,...JSON.parse(x.rowSettings).value,...valuejson}
      })); 
    });
    this.itemBodyList=[...this.bodyItemLines.value.map((x,index)=>{
      return {
        index:index,...x
      }
    })];
    (this.templateForm.get('topHeaderLines') as FormArray).clear();
    const addressDetail = data?.branchWiseAddressDetail;
    
        if (!addressDetail || Object.keys(addressDetail).length === 0) {
          this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
          this.topHeaderLines.clear();
        
          template?.temp_title?.topHeaderLines
            ?.filter(x => !!x.name)
            .forEach(x => {
              this.topHeaderLines.push(this.fb.group({
                name: x.name,
                value: x.value,
                fontsize: x.fontsize
              }));
            });
        
          this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
          this.FooterLines.clear();
        
          template?.footer?.bottomLines
            ?.filter(x => !!x.name)
            .forEach(x => {
              this.FooterLines.push(this.fb.group({
                name: x.name,
                value: x.value,
                fontsize: x.fontsize
              }));
            });
        } else {
          this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
          this.topHeaderLines.clear();
        
          const headerLines = JSON.parse(addressDetail.templateHeaderConfig || '[]');
          headerLines.forEach((line: any) => {
            this.topHeaderLines.push(this.fb.group({
              name: line.name,
              value: line.value,
              fontsize: line.fontsize
            }));
          });
        
          this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
          this.FooterLines.clear();
        
          const footerLines = JSON.parse(addressDetail.templateFooterConfig || '[]');
          footerLines.forEach((line: any) => {
            this.FooterLines.push(this.fb.group({
              name: line.name,
              value: line.value,
              fontsize: line.fontsize
            }));
          });
        }
        if(!!template?.temp_title){
          delete template?.temp_title['topHeaderLines']
          for(let x of this.objectKeys(template?.temp_title)){  
            try{
              if(!!this.templateForm.controls[x])
                this.templateForm.controls[x].setValue(template?.temp_title[x])
            }catch(Execption){}
          }
        }
    if(!!template?.footer){
      delete template?.footer['bottomLines']
      for(let x of this.objectKeys(template?.footer)){  
        try{
          if(!!this.templateForm.controls[x])
            this.templateForm.controls[x].setValue(template?.footer[x])
        }catch(Execption){}
      }  
    }
    this.onPreview();
  }
  onprint(){
    this.templatePreview=this.templateForm.value;  
  }
  setformtewoValue(control,val){
    this.fontdialogForm.controls[`${control}`].setValue(val);  
  }
  async onPreview(){
    this.templatePreview=this.templateForm.value; 
    this.config.styles.push(`@media print { 
              @page
              { 
                margin-top: ${this.templatePreview?.tm}px !important;
              }
            }`); 
    await this.sleep(1000) 
    this.pageTitleList.filter(async (x,index)=>{
      var headerval={...x.headerstyle,elementVal:null};
      var headerelem=document.getElementById("pageheaderhead"+index) as HTMLElement;       
      if(!!headerelem){
        headerval.elementVal=headerelem;
        this.onFontDialogValueChanged(headerval); 
      }
      var bodyval={...x.valuestyle,elementVal:null};
      var bodyelem=document.getElementById("pageheadervalue"+index) as HTMLElement;
      if(!!bodyelem){
        bodyval.elementVal=bodyelem;
        this.onFontDialogValueChanged(bodyval); 
      }
    });
    this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
       var headerval={...x.header.fontstyle,elementVal:null};       
       var headerelm=document.getElementById("itembodyheader"+index) as HTMLElement;
       if(!!headerelm){
          headerval.elementVal=headerelm;
          this.onFontDialogValueChanged(headerval); 
       }
       var bodyval={...x.value.fontstyle,elementVal:null};
       var bodyelem=document.getElementById("itembodyvalue"+index) as HTMLElement;
       if(!!bodyelem){
          bodyval.elementVal=bodyelem;
          this.onFontDialogValueChanged(bodyval); 
       }
    }); 
  }
sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
onFontDialogValueChanged(data){  
     if(!!data && !!data.elementVal)
        this.setfontstyle(data);
     if(!!this.commonStylechange){
      
      this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
        if(this.commonStylechange=="header"){
          var headerval=this.fontdialogForm.value;
          headerval.elementVal=document.getElementById("itembodyheader"+index) as HTMLElement;
          this.setfontstyle(headerval);
        }
        if(this.commonStylechange=="value"){
          var bodyval=this.fontdialogForm.value;
          bodyval.elementVal=document.getElementById("itembodyvalue"+index) as HTMLElement;
          this.setfontstyle(bodyval);  
        }
     }); 
    }
  }
  setfontstyle(data){
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    this.renderer.setStyle(data?.elementVal, 'color', data?.fontColor,flags);
    this.renderer.setStyle(data?.elementVal, 'font-size', data?.fontSize+'pt',flags);
    this.renderer.setStyle(data?.elementVal, 'font-family', data?.fontfamily,flags);
    this.renderer.setStyle(data?.elementVal, 'font-weight', data?.isBold?'bold':'normal',flags);
    this.renderer.setStyle(data?.elementVal, 'font-style', data?.isItalic?'italic':'normal',flags);
    this.renderer.setStyle(data?.elementVal, 'text-decoration', data?.isUnderline?'underline':'none',flags);
    this.renderer.setStyle(data?.elementVal, 'text-align', data?.textAlign,flags);
    this.renderer.setStyle(data?.elementVal, 'line-height', data?.textheight,flags);
    this.renderer.setStyle(data?.elementVal, 'padding-left', data?.indent+"px",flags); 
  }
   fontdialog(event,commonStylechange?){ 
    if(!!commonStylechange)
      this.commonStylechange=commonStylechange;
    else
      this.commonStylechange=null;
    var existdata=JSON.parse(JSON.stringify(event?.style)); 
    var res=existdata?.color.replace("rgb",'').replace("(",'').replace(')','').split(",").map(Number); 
  
    this.fontdialogForm.setValue({
          "elementVal": event,
          "fontfamily": this.commonSettings.fontfamily,
          "fontColor": rgbToHex(res[0],res[1], res[2]),
          "fontSize": parseInt(existdata?.fontSize.split("pt")[0]),
          "isBold": !!existdata?.fontWeight ? existdata?.fontWeight=="bold"?true:false : false,
          "isItalic": !!existdata?.fontStyle ? existdata?.fontStyle=="italic"?true:false : false,
          "isUnderline": !!existdata?.textDecoration ? existdata?.textDecoration=="underline"?true:false : false,
          "linespace":  !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
          "textAlign": !!existdata?.textAlign ? existdata?.textAlign : "left",
          "outdent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])):'0',
          "indent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])) :'0',
          "textheight": !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
     });   
     var returndata=this.fontdialogForm.value;
     delete returndata['elementVal'];
     return returndata;
   }
   setpragraph(type,value){
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    var data_=this.fontdialogForm.controls['elementVal'].value; 
    var existdata=JSON.parse(JSON.stringify(data_?.style));
    var margindata=0; 
    if(type=="indent"){
      margindata=5;
      if(existdata.paddingLeft!="")
        margindata=(parseInt(existdata.paddingLeft.split("px")[0])+5) 
        this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags); 
    }
    else if(type=="outdent"){
      margindata=parseInt(existdata.paddingLeft.split("px")[0]);
      if(margindata>=0)
        margindata=margindata-5;
      else         
        margindata=margindata-5;
        this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags); 
    }
    if(!!this.commonStylechange)
      this.fontdialogForm.controls['indent'].setValue(margindata);
  }
  checkpageTitleVisible(){
    var data=this.pageTitleList?.find(x=>x.display==true) 
    if(!!data)
      return true;
    else
      return false;
  }

  getPatientAgeByDOB(dob,ageResult,dobFlag): any{

    if(dobFlag=="Y"){
    
       var patientDob=new Date(dob);
    
       var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
         ageValue= Math.trunc(ageValue);
        //extract the year, month, and date from user date input  
        var dobMonth = patientDob.getMonth();  
        var dobDate = patientDob.getDate();  
          
        //get the current date from the system  
        var now = new Date();  
        //extract the year, month, and date from current date  
        var currentMonth = now.getMonth();  
        var currentDate = now.getDate();  
        
        //get months  
        if (currentMonth >= dobMonth)  
          //get months when current month is greater  
          var monthAge = currentMonth - dobMonth;  
        else {  
         // yearAge--;  
          var monthAge = 12 + currentMonth - dobMonth;  
        }  
      
        //get days  
        if (currentDate >= dobDate)  
          //get days when the current date is greater  
          var dateAge = currentDate - dobDate;  
        else {  
          monthAge--;  
          var dateAge = 31 + currentDate - dobDate;  
      
          if (monthAge < 0) {  
            monthAge = 11;  
          //  yearAge--;  
          }  
        }  
    return ageValue+' Y '+monthAge+' M '+dateAge+' D'
    
    }else{
    
    
      if(ageResult!=null){
    
      var patientAgeResult=new Date(ageResult);
    
      var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
       ageValue= Math.trunc(ageValue); //Get Before Decimal Value
    
        //extract the year, month, and date from user date input  
        var dobYear = patientAgeResult.getFullYear();  
        var dobMonth = patientAgeResult.getMonth();  
        var dobDate = patientAgeResult.getDate();  
          
        //get the current date from the system  
        var now = new Date();  
        //extract the year, month, and date from current date  
        var currentMonth = now.getMonth();  
        var currentDate = now.getDate();  
      
        //get months  
        if (currentMonth >= dobMonth)  
          //get months when current month is greater  
          var monthAge = currentMonth - dobMonth;  
        else {  
         // yearAge--;  
          var monthAge = 12 + currentMonth - dobMonth;  
        }  
      
        //get days  
        if (currentDate >= dobDate)  
          //get days when the current date is greater  
          var dateAge = currentDate - dobDate;  
        else {  
          monthAge--;  
          var dateAge = 31 + currentDate - dobDate;  
      
          if (monthAge < 0) {  
            monthAge = 11;  
          }  
        }  
    return ageValue+' Y '+monthAge+' M '+dateAge+' D'
    }else{
      return '-'
    
    }
    } 
   }
   valueChange(value,event,index){ 
      this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
      var val=this.bodyItemLines.controls[index].value;
      
      val.value.itemvalue=value
      this.bodyItemLines.controls[index].setValue(val);  
   }
   getDistempl(){

   }

  //   
   savePatientDischargeTemp(event:any): void {
    this.onPreview();
     event.target.disabled=true; 
     this.isSubmitted = true;
     this.isBtnSubmitted = true;
     var trimedval=(this.templateForm.get('templatename').value).replace(/\s+/g, ' ').trim(); 
     var setings=this.jsontodb(this.commonSettings,this.templateForm.value);
     var tempSettings=JSON.parse(JSON.stringify(setings));
     if (this.templateForm.valid && trimedval!="") {
      this.spinner.show();
      var tempdetails=JSON.parse(JSON.stringify(tempSettings));
      delete tempSettings['temp_title'];
      delete tempSettings['footer'];
      delete tempSettings['page_title'];
       var newDischargeTmplData = {
        regId:this.regId,
        admissionId:0,
        WOID:this.wonumber,
        WODetId:this.woDetId,
        templateId:this.templateData.id,
        templateName:this.templateForm.get("templatename").value,
        displayDepartment:null,
        displayPhysician:null, 
        dischargeSummaryStatus:null,
        dischargeSummaryDeliveryStatus:null,
        dischargeSummaryDeliveryDate:new Date(),
        dischargeSummaryDeliveryMode:null,
        dischargeSummaryReceiverDetail:null,
        dischargeSummaryReceiverFeedback:null, 
        reportHeader:null,
        reportFooter:null,
        footer:JSON.stringify(tempdetails.footer),
        displaySettings:JSON.stringify(tempSettings),
        temptitle:JSON.stringify(tempdetails.temp_title),
        pagetitle:JSON.stringify(tempdetails.page_title),
        tenantId:this.tenandId,
        branchId:this.branchId,
        createdDate:new Date(),
        createdBy:parseInt(this.createdBy),
        updatedDate:null,
        updatedBy:null,
        updatedIP:null,
        createdIP:null,
        dischargeTemplateTransDet:[], 
       }; 
       newDischargeTmplData.dischargeTemplateTransDet=[];
       newDischargeTmplData.dischargeTemplateTransDet=this.templatePreview.bodyItemLines?.map((x,index)=>{
           
        var data= {
              "tmplId": this.templateData?.id,
              "rowId": index+1,
              "id":!!this.editDischargeData?this.editDischargeData?.details[index]?.id:null,
              "rowHeader": x.header.itemvalue,
              "rowDefaultValue": this.itemvalue[index].value,
              "rowSettings": JSON.stringify(this.itemtblsettings(x,index)),
              "displayPosition":!!this.editDischargeData?this.editDischargeData?.details[index]?.displayPosition:null,
              "tempTransMstId":!!this.editDischargeData?this.editDischargeData?.details[index]?.tempTransMstId:null,
              "tenantId": this.tenandId,
              "branchId":this.branchId
          }
          if(!!!this.editDischargeData){
            delete data['id'];
            delete data['tempTransMstId']; 
          }
          return data;
         }          
       );
        //
       if(!!!this.editDischargeData){        
        this.DischargeTmplSrvc.create("PatientDischargeTmpl/" + this.tenandId+"/"+this.branchId+"/saveDischargeTemplate", newDischargeTmplData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
              this.save_discharge_summary = true;
              setTimeout(() => {
                this.save_discharge_summary = false;
              }, 2000);
          this.spinner.hide();
       }, (error) => {
          this.spinner.hide();
          event.target.disabled=false;  
          this.isSubmitted = false;
          this.isBtnSubmitted = false; 
          this.erroeSavemsg = true;
          setTimeout(() => {
            this.erroeSavemsg = false;
          }, 4000);
       }, () => { 
          event.target.disabled=false; 
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.loaddataonEdit();
          this.spinner.hide();
        }); 
       }
       else{
        newDischargeTmplData["id"]=this.editDischargeData?.header?.id;
        newDischargeTmplData.createdBy=this.editDischargeData?.header?.createdBy;
        newDischargeTmplData.createdDate=this.editDischargeData?.header?.createdDate;
        newDischargeTmplData.updatedBy=parseInt(this.createdBy);
        newDischargeTmplData.updatedDate=new Date();
        this.DischargeTmplSrvc.update(this.apiUrl+"/PatientDischargeTmpl/" + this.tenandId +"/"+this.branchId+"/"+this.editDischargeData?.header?.id+"/update", newDischargeTmplData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.spinner.hide();
            this.update_discharge_summary = true;
            setTimeout(() => {
              this.update_discharge_summary = false;
            }, 2000);
        }, (error) => {
          this.spinner.hide();
          event.target.disabled=false;  
          this.isSubmitted = false;
          this.isBtnSubmitted = false; 
          this.erroeSavemsg = true;
          setTimeout(() => {
            this.erroeSavemsg = false;
          }, 4000);
        }, () => { 
          event.target.disabled=false; 
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.loaddataonEdit();
           }); 
          this.spinner.hide(); 
         }
     }
     else
     {
        this.spinner.hide();
        this.templateForm.controls['templatename'].markAsDirty();
        event.target.disabled=false;
        this.isBtnSubmitted = false; 
       return;
     }
   }
   open_confirmation_popup(){
      this.cancelDialog=true;
   }
   close_confirmation_popup(){
      this.cancelDialog=true;
   }
   deleteDischargeSummary(){
      this.DischargeTmplSrvc.delete(`${this.apiUrl}/dischargeTmpl/${this.tenandId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
           
      }, (error) => {
      }, () => {
      });
   }
   
   itemtblsettings(data,index){
    var res=data; 
    res.header.fontstyle=this.fontdialog(document.getElementById("itembodyheader"+index) as HTMLElement)
    res.value.fontstyle=this.fontdialog(document.getElementById("itembodyvalue"+index) as HTMLElement)
    delete res.header['itemfontsize']
    delete res.header['itemfontfamily']
    delete res.header['itemfontcolor']
    delete res.header['itemposition']
    
    delete res.value['itemfontsize']
    delete res.value['itemfontfamily']
    delete res.value['itemfontcolor']
    delete res.value['itemposition']
    
    delete res.header['itemvalue']
    delete res.value['itemvalue']
    return res;
   }
  
   jsontodb(json,values){ 
     var  template={
      temp_title:{ 
        topHeaderLogoPosition: "center start",
        topHeaderLogoRequired: true,
        topHeaderPosition: "center end",
        topHeaderRequired: true,
        topHeaderheight: 60,
        topHeaderlineheight: 18,
        topheaderbgColor: null,
        topheaderfontColor: "#333333",
        topheaderfontfamily: null,
        pageTitle: null,
        pageTitleHeaderRequired: true,
        pageTitlefontsize: 14,
        topHeaderLines:[]
        }, 
      page_title:this.pageTitleSetttings,
      footer:{
            FooterLogoPosition: "center start",
            FooterLogoRequired: false,
            FooterPosition: "center end",
            FooterRequired: false,
            FooterbgColor: null,
            FooterfontColor: "#333333",
            Footerfontfamily: null,
            Footerheight: 60,
            Footerlineheight: 18,
            bottomDocsignLabel: "",
            bottomDocsignLabelsize: 12,
            bottomDocsignPosition: "center end",
            bottomDocsignftcol: null,
            bottomDocsignimg: null,
            bottomDocsignrequired: null,
            bottomLines:[]
      },
      bgColor:     values.bgColor,                                   
      bgimage:     null,
      imagewidth: values.imagewidth,
      bgposition:  null,
      ps: values.ps,
      orientation: values.orientation,
      tm: values.tm,
      bm: values.bm,
      lm: values.lm,
      rm: values.rm,
      bodylayout: values.bodylayout,
      temptype: values.temptype,
      labelColor: values.labelColor,
      fontColor: values.labelColor,
      fontSize: values.fontSize, 
      fontfamily: values.fontfamily,
    }; 
     template.page_title.fields=JSON.parse(JSON.stringify(this.pageTitleList))
    for(let x of this.objectKeys(json.temp_title)){  
      try{
      template.temp_title[x]=this.templateForm.controls[x].value
      }catch(Execption){}
    }
    template.temp_title.topHeaderLines=JSON.parse(JSON.stringify(this.topHeaderLines?.value.filter(x=> !!x.name)));
    for(let x of this.objectKeys(json.footer)){  
      try{
        template.footer[x]=this.templateForm.controls[x].value
      }catch(Exception){}
    }
    template.footer.bottomLines=JSON.parse(JSON.stringify(this.FooterLines.value.filter(x=> !!x.name)));  
    return template;
   }

   bodyEntermouse(type,i){
    this.itemvalue=this.itemvalue?.map((x,index)=>{
      x.displayeditor=index==i?true:false;
      x.displaytext=index==i?false:true;
      return {...x}
    })
   }
   downloadFile(){ 
     
    var pageTitle="ssss"
    var styles='';
    this.config.stylesheets.filter(x=>{
      styles=styles+`<link rel='stylesheet' href='${x.href}'> `;
    });
    var printContent=` 
      <head>
      <title>${pageTitle}</title>
          ${styles}
      </head>
      <body>       
        <div class="print-content">
          ${this.printcontent.nativeElement.innerHTML}
        </div>  
      </body> `; 
     this.downloadHtml=printContent;
   
    html2canvas(this.downloadpdf.nativeElement).then(canvas => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL("image/png");
      let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF
      var position = 0;
      pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
      pdf.save("MYPdf.pdf"); // Generated PDF
    }); 
     
   }

   loadHeader(wono , regid,status){
    this.srvc.listsubcategory(`${this.tenandId}/${this.branchId}/labworkordermst/getHeaderDetForGivenRegNum/${wono}/${regid}/${status}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.headerDet = data[0];
    });
   }

  //  replacing ezotemplate json value here :
   replaceVariableTostring(string){
    if(!!string){
      
      string=string.replace((new RegExp("{patientname}", "g")),this.headerDet.name)
     .replace((new RegExp("{patientage}", "g")),this.headerDet.age)
     .replace((new RegExp("{patientid}", "g")),this.headerDet.regNum)      
     .replace((new RegExp("{mobile}", "g")),this.headerDet.mobile)
     .replace((new RegExp("{patienttype}", "g")),this.headerDet.patientType)  
     .replace((new RegExp("{doctorname}", "g")),this.headerDet.doctor)  
     .replace((new RegExp("{admissionid}", "g")),(this.headerDet.admNum || '-'))
     .replace((new RegExp("{billid}", "g")),this.headerDet.billId || '-')
     .replace((new RegExp("{billdate}", "g")),this.datePipe.transform(this.headerDet.billDateTime, 'dd-MM-yyyy'))
     .replace((new RegExp("{workorderno}", "g")),this.headerDet.woNo || '-')
     .replace((new RegExp("{workorderdate}", "g")),this.datePipe.transform(this.headerDet.woDateTime,'dd-MM-yyyy'))

     .replace((new RegExp("{docname}", "g")),'Dr.'+this.headerDet.doctor)
     .replace((new RegExp("{patientgender}", "g")),this.headerDet.gender)
     .replace((new RegExp("{patientregdate}", "g")),this.headerDet?.regDate || '-')
    }
    return string;
   }
   onpreviewdialog(){
        this.onPreviewDialog=true;
   }
   getPatientTitle(title){
      return this.titleList?.find(x=>x?.value==title)?.title;
   }
   popoverclose(){ 
    if(this.popovers){
      this.popovers.forEach(popover => {
        popover.hide();
       });
   }
    this.popover.hide();
  }
} 

export function rgbToHex(r: number, g: number, b: number): string {
  if(!!r && !!g && !!b)
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  else
    return '#333333'
}